<table class="table">
  <thead>
    <th>Name</th>
    <th>Email</th>
    <th>Role</th>
    <th></th>
  </thead>
  <tbody>
    <tr *ngFor="let admin of org.Administrators" [class.hover]="deleteObj !== admin">
      <td (click)="goToRoute(admin, '/accounts/' + admin.AccountID)">
        <a [routerLink]="'/accounts/' + admin.AccountID">
          <app-profile-picture class="mr-2" [name]="admin.AccountName"></app-profile-picture>
          {{ admin.AccountName }}
        </a>
      </td>
      <td (click)="goToRoute(admin, '/accounts/' + admin.AccountID)">{{ admin.Email}}</td>
      <td>
          <select *ngIf="accountCanEditRoles()"
                  class="form-control"
                  [(ngModel)]="admin.RoleDescription"
                  (change)="updateAdmin($event, admin)">
            <option value={{role.Description}} *ngFor="let role of adminRoles">{{role.Description}}</option>
          </select>
          <span *ngIf="!accountCanEditRoles()">{{admin.RoleDescription}}</span>
      </td>
      <td class="text-center icon">
        <span (click)="deleteAdmin($event, admin)" *ngIf="deleteObj !== admin" ngbTooltip="Delete">
          <i *ngIf="admin.ID !== acctID" class="fal fa-trash-alt pointer"></i>
        </span>
        <span *ngIf="deleteObj === admin">
          <i class="fal fa-spinner fa-spin"></i>
        </span>
      </td>
    </tr>
  </tbody>
</table>
